<template>
	<div class="rechargePage" :class="!isMobile ? 'pcbox' : ''">
		<div class="title" v-if="!isMobile">
			<h2>{{ $t('pay.title') }}</h2>
		</div>
		<div class="rechargeTop">
			<div class="backBtn" @click="handleBack" v-if="isMobile">
				<van-icon name="arrow-left" size="24" />
			</div>
			<div class="mycoins gmcoins">
				<h3>{{ $t('personal.payPlatCoin') }}</h3>
				<p>{{ payGmcoin }}</p>
			</div>
			<div class="mycoins">
				<h3>{{ $t('personal.myPlatCoin') }}</h3>
				<p>{{ platCoin }}</p>
			</div>
			<div class="mycoins gmcoupons">
				<h3>{{ $t('personal.myPlatCoupons') }}</h3>
				<p>{{ platCoupons }}</p>
			</div>
		</div>
		<div class="rechargeBox">
			<h4>{{ $t('pay.rechargeTitle') }}</h4>
			<div class="rechargeList">
				<ul>
					<template v-for="(item,index) in coinlist" :key="index">
						<!-- <li class="rechargeItem" :class="{'active':item.money == activeVal}" @click="handleCoin(item)">
							<span class="tag" v-if="payStatus !== 1 && index == 0">{{ $t('pay.rechargeDiscount') }}</span>
							<van-image width="100" height="100" :src="require(`@/assets/images/common/coin_icon.png`)" />
							<p class="desc"><i class="icoin"></i>{{ item.gmCouponNum }}
								
								<span class="num"> + <i class="gcoin"></i>{{ (item.firstBuy).toFixed(0) }}</span>
							</p>
							
							<p style="margin-top: 0.5rem;">{{ item.goodName }}</p>
							<van-button style="margin-top: 1.25rem;" color="linear-gradient(to right, #FE454D, #FF6F57)" block round :loading="payLoading" @click="handleRecharge(item)">
							₩ {{ item.money }}
							</van-button>
						</li> -->
						<li class="rechargeItems" :class="{'active':item.money == activeVal}" @click="handleCoin(item)">
							<i class="discountTag" :class="{'percent20':item.discount == 0.2,'percent25':item.discount == 0.25}"></i>
							<div class="itemboxs">
								<div class="details">
									<span><i class="gmcoin"></i>{{ item.gmCouponNum }}</span>
									<span>+</span>
									<span><i class="gmcoupon"></i>{{ item.giftNum }}</span>
								</div>
								<div class="titles van-ellipsis">{{ item.goodName }}</div>
								<div class="orimoneys">₩{{ item.originalPrice }}</div>
								<!-- <div class="moneys" @click="handleRecharge(item)">₩{{ item.money }}</div> -->
								<van-button class="moneys" color="transparent" block :loading="payLoading" @click="handleRecharge(item)">
								₩{{ item.money }}
								</van-button>
							</div>
						</li>
					</template>
				</ul>
				<!-- <van-cell-group inset>
				  <van-field clearable type="digit" v-model="rechargeVal" readonly
					  :label="$t('pay.rechargeMoney')" 
					  :placeholder="$t('pay.rechargePlaceholder')"
					  :disabled="payLoading"
					   @update:model-value="inputChange"
				   >
					  <template #button>
						  <span style="color: #FE454D" v-if="payStatus !== 1">{{ $t('pay.rechargeDiscount',{ num: rechargeNum }) }}</span>
				       </template>
				 </van-field>
				</van-cell-group> -->
			</div>
			<div class="rechargeDescs">
				<p>{{ $t('personal.gmdesc1') }}</p>
				<p>{{ $t('personal.gmdesc11') }}</p>
				<p>{{ $t('personal.gmdesc2') }}</p>
				<p>{{ $t('personal.gmdesc3') }}</p>
			</div>
			<!-- <div class="btnBox">
				<van-button color="linear-gradient(to right, #FE454D, #FF6F57)" block round :loading="payLoading" @click="handleRecharge">{{ $t('pay.payRecharge') }}</van-button>
			</div> -->
		</div>
		
		<!-- 登录 -->
		<Login :showLogin="openLogin" @loginSuccess="loginSuccess" />
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed, reactive, onUnmounted } from 'vue'
	import { useRouter } from 'vue-router';
	import useUserStore from '@/store/modules/user'
	import useConfigStore from '@/store/modules/config'
	import Login from '@/components/login'
	import { getGmPay, getGmPayFrist, getGmPayGoods, getUserMallInfo } from "@/api/gm";
	const { proxy } = getCurrentInstance();
	// const coinlist = ref([10000])
	const router = useRouter();
	const coinlist = ref([])
	const rechargeVal = ref(10000)
	// const activeVal = ref(10000)
	const activeVal = ref(null)
	const activeItem = ref(null)
	const payLoading = ref(false)
	const openLogin = ref(false)
	const isMobile = computed(() => {
		return useConfigStore().isMobile
	})
	const userInfo = computed(() => {
		return useUserStore().userInfo
	})
	let goodInfo = reactive({//默认商品信息
		gameId: 1,
		goodId: 1,
		// goodName: '平台币',
		// num: 1,
		// voucher: 0,
		// voucherType: 0,
		// totalAmount: 0,
		userId: 0,
		source: 1
	})
	const payGmcoin = ref(0)
	const platCoin = ref(0)
	const platCoupons = ref(0)
	const payStatus = ref(1)
	const rechargeNum = ref(3)//首充3倍
	const init = () => {
		if(!useUserStore().userInfo.superUserId){
			openLogin.value = true
			return false
		}
		getUserMallInfo().then((res) => {
			payGmcoin.value = res.data.payGmCoin || 0
			platCoin.value = res.data.platCoin || 0
			platCoupons.value = res.data.gmCoupon || 0
		})
		// getGmPayFrist({ userId: useUserStore().userInfo.superUserId }).then((res) => {
		// 	payStatus.value = res.data.isBuy//1非首次购买 0首次购买
		// 	platCoin.value = res.data.platCoin
		// 	platCoupons.value = res.data.gmCoupon
		// 	// if(payStatus.value === 0){
		// 	// 	rechargeVal.value = (activeVal.value * rechargeNum.value).toFixed(0)
		// 	// }
		// })
		getGmPayGoods({ userId: useUserStore().userInfo.superUserId }).then((res) => {
			console.log(res)
			coinlist.value = res.data
			handleCoin(coinlist.value[0])
		})
	}
	const loginSuccess = () => {
		init()
		openLogin.value = false
	}
	const handleVisibilityChange = () => {
		if (document.visibilityState === 'visible'){
			init()
		}else{
			console.log('不可见')
		}
	}
	onMounted(() => {
		init()
		document.addEventListener('visibilitychange', handleVisibilityChange);
	})
	onUnmounted(() => {
		document.removeEventListener('visibilitychange', handleVisibilityChange);
	})
	const handleCoin = (row) => {
		if(payLoading.value){
			proxy.$toast('Loading...')
			return false
		}
		activeVal.value = row.money
		rechargeVal.value = row.money
		goodInfo.goodId = row.goodId
		activeItem.value = Object.assign({},row)
	}
	const inputChange = (val) => {
		activeVal.value = Number(val)
	}
	const handleBack = () => {
		history.back()
	}
	const handleRecharge = (row) => {
		handleCoin(row)
		if(rechargeVal.value%100 != 0){
			proxy.$toast(proxy.$t('pay.tipsInputRecharge'))
			return false
		}
		if(!useUserStore().userToken|| !useUserStore().userInfo.superUserId){
			proxy.$toast(proxy.$t('personal.tipsLogin'))
			return false
		}
		// goodInfo.totalAmount = rechargeVal.value
		goodInfo.userId = parseInt(useUserStore().userInfo.superUserId)
		console.log(goodInfo)
		payLoading.value = true
		
		router.push({
		  path:'/payplat',
		  query: { totalAmount: activeVal.value, goodName: activeItem.value.goodName, encode: proxy.$Base64.encode(JSON.stringify(goodInfo)) }
		});
		payLoading.value = false
		
		// getGmPay(goodInfo).then((res) => {
		// 	console.log(res)
		// 	if(res.data && res.data.redirectUrl){
		// 		window.open(res.data.redirectUrl,'_blank')
		// 	}else{
		// 		proxy.$toast(res.msg)
		// 	}
		// 	payLoading.value = false
		// }).catch(() => {
		// 	payLoading.value = false
		// })
	}
</script>

<style lang="less" scoped>
	.rechargePage{
		position: relative;width: 100%;height: calc(100vh - 40px);overflow-y: scroll;
		background: #2B2C30;
		.rechargeTop{
			height: 16.875rem;width: 100%;
			background: url('~@/assets/images/common/platcoin_bg.png') no-repeat;
			background-size: 100%;
			background-position-x: 3.75rem;
			background-position-y: 1rem;
			color: #fff;position: relative;
			.mycoins{
				position: absolute;bottom: 5rem;left: 1rem;
				h3{
					font-weight: normal;font-size: 0.9375rem;margin-bottom: 0.125rem;
				}
				p{
					font-size: 1.5rem;font-weight: 500;
				}
			}
			.gmcoupons{
				bottom: 1rem;left: 1rem;
			}
			.gmcoins{
				bottom: 9rem;left: 1rem;
			}
			.backBtn{
				position: absolute;left: 1rem;top: 1rem;
			}
		}
		.rechargeBox{
			background: #fff;width: 100%;height: calc(100% - 16.875rem);border-radius: 0.625rem 0.625rem 0 0;
			position: absolute;bottom: 0;left: 0;min-height: 15rem;;
			h4{
				padding: 0.8125rem 1rem 0;
			}
			.rechargeList{
				width: 100%;height: calc(100% - 148px);overflow-y: scroll;
			}
			.rechargeDescs{
				width: calc(100% - 2rem);background: #f4f4f5;color: #909399;line-height: 18px;
				font-size: 12px;margin: 12px auto;padding: 8px 12px;box-sizing: border-box;border-radius: 10px;
			}
			ul{
				display: flex;flex-wrap: wrap;margin-bottom: 0.625rem;padding: 0.75rem;box-sizing: border-box;
				li{
					width: 49%;margin-right: 2%;text-align: center;margin-top: 0.75rem;
					box-sizing: border-box;padding: 2rem 0.625rem 1rem;border-radius: 0.5rem;
					background: #fff;color: #303133;font-weight: 500;
					border: 0.125rem solid #f4f4f5;
					&:nth-child(2n){
						margin-right: 0;
					}
					&.active,&:hover{
						border: 0.125rem solid #FE4D4F;
						// background: #FFF0ED;
						background: #FFF;cursor: pointer;
					}
					&.rechargeItems{
						position: relative;margin-top: 0;
						border: none;padding: 0.875rem 0.5rem 0.625rem;border-radius: 0;
						.discountTag{
							position: absolute;left: 0;top: 0;display: inline-block;
							height: 1.875rem;aspect-ratio: 136/48;
							&.percent20{
								background: url('~@/assets/images/common/20p.png') no-repeat center;background-size: 100%;
							}
							&.percent25{
								background: url('~@/assets/images/common/25p.png') no-repeat center;background-size: 100%;
							}
						}
						.itemboxs{
							width: 100%;aspect-ratio: 225/241;padding-top: 50%;box-sizing: border-box;
							background: url('~@/assets/images/common/paycoinbg.png') no-repeat center;background-size: 100%;
							.details{
								height: 20%;color: #622600;font-size: 0.75rem;
								display: flex;align-items: center;justify-content: center;gap: 0.125rem;
								span{
									display: inline-flex;align-items: center;gap: 0.0625rem;
								}
								i{
									display: inline-block;width: 1rem;height: 1rem;position: relative;
									&::before{
										display: block;position: absolute;left: 0;bottom: 0;width: 100%;height: 100%;content: '';z-index: 0;
										background: url('~@/assets/images/common/paycoin_ibg.png') no-repeat center;background-size: 100%;
									}
								}
								.gmcoin{
									&::after{
										display: block;position: absolute;left: 0;bottom: 0;width: 100%;height: 100%;content: '';
										background: url('~@/assets/images/common/coin_icon.png') no-repeat center;background-size: 80%;
										z-index: 1;
									}
									
								}
								.gmcoupon{
									&::after{
										display: block;position: absolute;left: 0;bottom: 0;width: 100%;height: 100%;content: '';
										background: url('~@/assets/images/common/gmcoupon.png') no-repeat center;background-size: 90%;
										z-index: 1;
									}
									
								}
							}
							.titles{
								height: 22%;color: #101010;padding-top: 0.125rem;font-size: 0.75rem;
								width: 78%;display: flex;align-items: center;justify-content: center;
								margin: 0 auto;
							}
							.orimoneys{
								height: 22%;text-decoration: line-through;color: #AB7E4B;font-size: 0.875rem;
								width: 100%;display: flex;align-items: center;justify-content: center;
							}
							.moneys{
								height: 36%;width: 100%;display: flex;align-items: center;justify-content: center;
								font-weight: 600;color: #fff;font-size: 1.25rem;
							}
						}
					}
					&.rechargeItem{
						position: relative;
						
						.tag{
							display: inline-block;position: absolute;left: 0;top: 0;
							background: #FFF0ED;color: #FE4D4F;font-size: 0.6875rem;
							padding: 0.1875rem 0.625rem;box-sizing: border-box;
							border-radius: 0.5rem 0 0.5rem;
						}
						p{
							display: flex;align-items: center;justify-content: center;
						}
						.icoin{
							display: inline-block;width: 1rem;height: 1rem;margin-right: 0.3125rem;
							background: url('~@/assets/images/common/coin_icon.png') no-repeat center;background-size: 100%;
						}
						.gcoin{
							display: inline-block;width: 1rem;height: 1rem;margin-right: 0.1875rem;margin-left: 0.1875rem;
							background: url('~@/assets/images/common/gmcoupon.png') no-repeat center;background-size: 100%;
						}
						.desc{
							margin-bottom: 0.75rem;font-size: 0.75rem;color: #999;margin-top: 0.3125rem;font-weight: 400;
							span.num{
								margin-left: 5px;
								display: inline-flex;align-items: center;
								.icoin{margin-left: 5px;}
							}
							.icoin{
								width: 0.75rem;height: 0.75rem;
							}
						}
					}
				}
			}
			.btnBox{
				padding: 0.75rem 1rem;position: absolute;left: 0;bottom: 0;width: 100%;box-sizing: border-box;
			}
			/deep/.van-cell-group{
				background: #F0F1F1;
				.van-cell{
					background: #F0F1F1;font-weight: 500;
				}
			}
		}
		&.pcbox{
			display: flex;align-items: flex-start;justify-content: center;
			max-width: 1060px;background: transparent;padding-top: 100px;height: calc(100vh - 260px);
			.title{
				position: absolute;left: 0;top: 0;line-height: 120px;
			}
			.rechargeTop{
				width: 220px;height: 560px;
				background-color: #2B2C30;
				background-image: url('~@/assets/images/common/platcoin_bg.png');
				background-repeat: no-repeat;
				background-size: 170%;
				background-position-x: 50%;
				background-position-y: -1.25rem;
				.mycoins{
					position: absolute;bottom: 4.5rem;left: 1rem;
					h3{
						font-size: 16px;
					}
					p{
						font-size: 30px;
					}
				}
				.gmcoupons{
					bottom: 1rem;left: 1rem;
				}
				.gmcoins{
					bottom: 8rem;
				}
			}
			.rechargeBox{
				width: 840px;height: 560px;position: relative;border-radius: 0;
				.btnBox{
					padding: 1.25rem 1rem;
				}
				ul{
					li{
						width: 32.5%;margin-right: 1.25%;
						&:nth-child(3n){
							margin-right: 0;
						}
					}
				}
			}
		}
	}
	
</style>